// extracted by mini-css-extract-plugin
module.exports = {"taboolaWrapper":"taboola_taboolaWrapper__r9hv0"};